<template>
  <div id="modifiersPriorityEdit">
    <TipBox info :title="$t('tips.display_priority')">
      <span v-html="$t('tips.display_priority_description')"></span>
    </TipBox>
    <Panel :title="$t('display_priority')">
      <Draggable v-model="groups"  @start="drag=true" @end="drag=false">
        <div v-for="select in groups" class="item-checkbox-line">
          <svgicon src="icon/hamburger.svg" :height="12" :width="12"></svgicon>
          <label :for="`chk_${select.id}`">{{getGroupName(select.id)}}</label>
          <tag v-if="select.note">{{ select.note }}</tag>
        </div>
      </Draggable>
    </Panel>
    <div class="footer-actions" v-if="!$store.getters.isBranchContextInventory">
      <button class="btn btn-primary" @click="save">{{$t("save")}}</button>
    </div>
  </div>
</template>
<script>
  import { Core } from "@/core/Core";
  import Draggable from 'vuedraggable';
  import { mapActions } from 'vuex';

  export default {
    name: "ModifierGroupPriority",
    components: { Draggable },

    data() {
      return {
        ready: false,
        inventory: null,
        groups: [],
        data: {
          id: null,
          type: "",
          selected: [],
          groupsPriorities: {},
        }
      }
    },

    computed: {
      inventoryReference() {
        return this.$store.state.contextCompany ? this.$store.state.contextCompany.nameCanonical : this.inventory.id;
      }
    },

    async mounted() {
      this.inventory = await this.$store.getters.getContextInventory;
      Promise
        .all([
          Core.request("GET", `/api/inventory/${this.inventoryReference}/modifier_groups?augment=backend`),
        ])
        .then(([modifiersGroups]) => {
          this.groups = modifiersGroups;
        })
        .finally(() => {
          this.$store.commit('showSpinner', false);
        })

    },

    methods: {

      ...mapActions(['saveModifierGroupsPriorities']),

      getGroupName(id) {
        for (let group of this.groups) {
          if (group.id === id) {
            return this.$to(group.name);
          }
        }
      },
      async save() {
        this.$store.commit("showSpinner", true);
        let response = await this.saveModifierGroupsPriorities({inventoryId: this.inventoryReference, data: {items: this.groups}});
        if (!response) {
          toast(this.$t("modifiers.error.save"), "error");
          this.$store.commit("showSpinner", false);
          return;
        }
        this.$store.commit("showSpinner", false);
      }
    }
  }
</script>

<style lang="scss" scoped>
.item-checkbox-line {
  background-color: #f2f2f2;
  margin: 5px 0;
  border-radius: 6px;
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: grab;
  max-width: 900px;

  &:not(:last-child) {
    margin-bottom: 5px;
  }

  label {
    flex-grow: 1;
  }

  .svgicon {
    fill: #ccc;
    margin-right: 20px;
  }

  .tag {
    text-transform: none;
    font-weight: normal;
    border-radius: 6px;
    padding: 4px 10px;
    font-size: 14px;
  }
}
</style>
